import type {AccountSettingsData} from 'src/modules/create-account/typedef';
import type {AccountSettings} from 'src/openapi/admin/models/AccountSettings';

export const BUSINESS_LINE_PLATFORM_CODE = 'Platform';
export const BUSINESS_LINE_DIRECT_DATA_CODE = 'Direct Data';
export const BUSINESS_LINE_MEDIA_CODE = 'Media';
export const BUSINESS_LINE_MIERS_CODE = 'MIERS';

export const mapAccountSettingsToData = (data: AccountSettings): AccountSettingsData => {
    return {
        untrackedAccount: data.untracked,
        fullStory: data.screenRecording,
        liveAgent: data.liveChatEnabled,
        pbPioneer: data.pbPioneer,
        platform: data.businessLinesCode?.includes(BUSINESS_LINE_PLATFORM_CODE),
        directData: data.businessLinesCode?.includes(BUSINESS_LINE_DIRECT_DATA_CODE),
        media: data.businessLinesCode?.includes(BUSINESS_LINE_MEDIA_CODE),
        miers: data.businessLinesCode?.includes(BUSINESS_LINE_MIERS_CODE),
        projectCodeEnabled: data.projectCodesEnabled,
        projectCodeRequired: data.projectCodesRequired,
        salesforce: data.sfCommunitiesEnabled,
        accreditationStatus: data.accreditationStatus,
    };
};

export const mapAccountDataToSettings = (data: AccountSettingsData): AccountSettings => {
    return {
        untracked: data.untrackedAccount,
        screenRecording: data.fullStory,
        liveChatEnabled: data.liveAgent,
        pbPioneer: data.pbPioneer,
        businessLinesCode: [
            data.platform ? BUSINESS_LINE_PLATFORM_CODE : '',
            data.directData ? BUSINESS_LINE_DIRECT_DATA_CODE : '',
            data.media ? BUSINESS_LINE_MEDIA_CODE : '',
            data.miers ? BUSINESS_LINE_MIERS_CODE : '',
        ].filter(e => e),
        projectCodesEnabled: data.projectCodeEnabled,
        projectCodesRequired: data.projectCodeRequired,
        sfCommunitiesEnabled: data.salesforce,
        accreditationStatus: data.accreditationStatus,
    };
};

type BusinessLineCodes = 'platform' | 'directData' | 'media' | 'miers';

export const MAP_BUSINESS_LINE_FIELD_NAMES: Record<string, BusinessLineCodes> = {
    [BUSINESS_LINE_PLATFORM_CODE]: 'platform',
    [BUSINESS_LINE_DIRECT_DATA_CODE]: 'directData',
    [BUSINESS_LINE_MEDIA_CODE]: 'media',
    [BUSINESS_LINE_MIERS_CODE]: 'miers',
};
